import React from 'react'
import { Link } from 'react-router-dom'
import Button from '../../components/Button/Button'
import style from './Prepare.module.css'
import smile from '../../assets/smile.png'
import { useState, useEffect } from 'react'
import { useGetQuestionsQuery } from '../../redux/questionsApi';
import BarLoader from "react-spinners/BarLoader";

const Prepare = ({nameToDisplay, setStep}) => {

    const name = nameToDisplay;
    const [questions, setQuestions] = useState([]);
    const { data, isFetching } = useGetQuestionsQuery();

    const override = {
        display: "block",
        margin: "10px auto",
        borderColor: "red",
    };

    useEffect(() => {
        if(!isFetching) {
            setQuestions(Object.values(data));
        }
    }, [data, isFetching]);

    return (  
      <div className={style.container}>
        <h1 className={style.title}>Tenés 30 segundos para responder cada una de las siguientes 7 (siete) preguntas.</h1>
        {
          isFetching 
          ? 
            <div>
              <BarLoader color={"#0D698A"} loading={isFetching} cssOverride={override} size={20} />
              <span className={style.loading_message}>Cargando Preguntas</span> 
            </div>
          : 
            <div className={style.middle}>
              <img className={style.emoji} src={smile} alt="smile-emoji" />
              <p className={style.text} onClick={() => {console.log(questions)}}>¿Arrancamos, {name}?</p>
            </div>
        }
        <div className={style.button}>
          <Button text='Empezar' onClick={() => setStep(3)}/>
        </div>
      </div>
    ) 
}

export default Prepare  